import React, {useState} from 'react'
import RangeSlider from './RangeSlider'
import { translate } from '../Services/translation'
import constants from '../constants'

export default function RimSerachDrawer({filters, onFacetChange, showDrawer, handleCloseSearchDrawer, totalHits, vehicleData}) {
    const [isAllSeasonActive, setIsAllSeasonActive] = useState(filters.allseason?.selectedOptions?.includes("true"))
    const handleSetAllseason = () => {
        setIsAllSeasonActive(!isAllSeasonActive)
        onFacetChange(filters.AllSeason, "true", true, null, false)
    }

    return (
        <div className={`drawer-container ${showDrawer && "drawer-container--show"}`}>
            <span onClick={handleCloseSearchDrawer} className="icon-close">
            </span>
            <div className="drawer-content">
                <h3>{translate("facet.header.changesearch")}</h3>
                <div className="filter-row">
                    <b>{translate("facet.header.size")}</b>
                    <select 
                        value={filters[constants.filterTags.diameter]?.selectedOptions[0]}
                        onChange={e => onFacetChange(filters[constants.filterTags.diameter], e.target.value, true, null, true)}
                    >
                        {vehicleData.rims.map(rim => 
                            <option value={rim.diameter} key={rim.diameter}>
                                {rim.diameter}"
                            </option>
                        )}
                    </select>
                </div>
                {filters.Brand && [filters.Brand].map(filter => (
                    <div className="filter-row" key={filter.id}>
                        <b>{filter.label}</b>
                        <div className="side-scroll-filter">
                            {filter.options.filter(option => option.quantity > 0).map(option => (
                                <button 
                                    key={option.id}
                                    className={filter.selectedOptions.some(x => x === option.id) ? "active" : ""} 
                                    onClick={() => onFacetChange(filter, option.id, true)}>
                                    {option.label}
                                </button>
                            ))}
                        </div>
                    </div>
                ))}
                <div className="filter-row">
                 <b>{translate("facet.header.allseason")}</b>
                 <input checked={isAllSeasonActive} onChange={handleSetAllseason} type="checkbox" />
                </div>
                <div className="filter-row">
                    <b>{translate("facet.header.price")}</b>
                    <RangeSlider 
                        filter={filters.price_range}
                        onFacetChange={onFacetChange}
                    />
                </div>
            </div>
            <div className="show-result-button-container">
                <button onClick={handleCloseSearchDrawer} className="show-result-button">
                    {translate("facet.showhits")} {totalHits && <>({totalHits})</>}
                </button>
            </div>
        </div>
    )
}